import { EcplLarViewerComponent } from './ecpl-lar-viewer.component';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { TableModule } from 'primeng/table';
import { SelectModule } from 'primeng/select';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { WidgetsModule } from 'src/app/kuba/shared/widgets.module';

@NgModule({ exports: [WidgetsModule, EcplLarViewerComponent],
    declarations: [EcplLarViewerComponent],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    WidgetsModule,
    RouterModule,
    TranslatePipe, TranslateDirective,
        SelectModule,
    DialogModule,
    TableModule,
    ConfirmDialogModule
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class EcplLarViewerModule {}
